<template>
  <div class="d-flex w-100">
    <button
      v-for="option in options"
      :key="option.value"
      class="toggle-btn text-accelerate-grey-1 mobile-touch-target"
      :class="{ active: modelValue === option.value }"
      @click="handleToggle(option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script>
import { DataLayerMixin } from '../../mixins/dataLayerMixin';
export default {
  mixins: [DataLayerMixin],
  name: 'CustomToggle',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue'],
  methods: {
    handleToggle(value) {
      this.asuoDataLayerClick('accelerateDashboard', '26', { text: value });
      this.$emit('update:modelValue', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle-btn {
  flex: 1;
  background: transparent;
  border: 1px solid #bfbfbf;
  padding: 8px 16px;
  cursor: pointer;
  margin: 0;
  transition: all 0.2s ease;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.toggle-btn:not(:last-child) {
  margin-right: -1px; // Use negative margin instead of removing border
}

.toggle-btn:first-child {
  border-radius: 8px 0 0 8px;
}

.toggle-btn:last-child {
  border-radius: 0 8px 8px 0;
}

.toggle-btn.active {
  background: #eaf9ff;
  border-color: #006388;
  color: #006388;
  z-index: 1;
  font-weight: bold;
}

.toggle-btn:hover:not(.active) {
  background: rgba(0, 99, 136, 0.5); // Add 50% transparancy on hover
}
</style>
